import ReportProductDetails from './ReportProductDetails';
export default ReportProductDetails;